import { render, staticRenderFns } from "./stocking.vue?vue&type=template&id=24a3a0cf&"
import script from "./stocking.vue?vue&type=script&lang=js&"
export * from "./stocking.vue?vue&type=script&lang=js&"
import style0 from "./stocking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports